const { COUNTRY_CODES, CURRENCY, REGEX } = require('./constants')

function isAlphaNumeric(str) {
  return REGEX.ALPHANUMERIC.test(str)
}

function isEmptyObject(obj) {
  return typeof obj == 'object' && Object.keys(obj).length === 0
}

function isNullOrUndefined(argument) {
  return argument === null || argument === undefined
}

function isNumeric(str) {
  return REGEX.NUMERIC.test(str)
}

function isValidCreditCard(creditCard) {
  if (new RegExp('/[^0-9-s]+/').test(creditCard)) {
    return false
  }
  let nCheck = 0
  let bEven = false
  let creditCardString = `${creditCard}`
  creditCardString = creditCardString.replace(/\D/g, '')
  for (let n = creditCardString.length - 1; n >= 0; n--) {
    const cDigit = creditCardString.charAt(n)
    let nDigit = Number.parseInt(cDigit, 10)
    if (bEven && (nDigit *= 2) > 9) {
      nDigit -= 9
    }
    nCheck += nDigit
    bEven = !bEven
  }
  return nCheck % 10 == 0
}

function isValidCurrency(currency) {
  return CURRENCY.includes(currency)
}

//TODO: Determine validation for date
function isValidDate(/*date*/) {
  return true
}

function isValidEmail(email) {
  return REGEX.EMAIL.test(email.toLowerCase())
}

function isValidISO31661Alpha2Country(country) {
  return COUNTRY_CODES.includes(country)
}

function isValidName(name) {
  return REGEX.NAME.test(name)
}

function isValidPhone(phone) {
  return REGEX.PHONE.test(phone)
}

function isValidPostalCode(postalCode, postalCodeFormat) {
  if (!postalCodeFormat) {
    return (
      REGEX['POSTAL_CODE_US'].test(postalCode) ||
      REGEX['POSTAL_CODE_CA'].test(postalCode)
    )
  }
  return REGEX[postalCodeFormat]
    ? REGEX[postalCodeFormat].test(postalCode)
    : false
}

function isValidState(str) {
  return REGEX.STATE.test(str)
}

function isValidCardMonth(cardMonth) {
  return REGEX.CARD_MONTH.test(cardMonth)
}

function isValidCardYear(cardYear) {
  return REGEX.CARD_YEAR.test(cardYear)
}

function isValidCardCvv(cvv) {
  return REGEX.CARD_CVV.test(cvv)
}

function isValidExternalId(externalId) {
  return REGEX.EXTERNAL_ID.test(externalId)
}

module.exports = {
  isAlphaNumeric,
  isNumeric,
  isEmptyObject,
  isNullOrUndefined,
  isValidCreditCard,
  isValidCurrency,
  isValidDate,
  isValidEmail,
  isValidISO31661Alpha2Country,
  isValidName,
  isValidPhone,
  isValidPostalCode,
  isValidState,
  isValidCardMonth,
  isValidCardYear,
  isValidCardCvv,
  isValidExternalId,
}
